import Decimal from 'decimal.js';

export const MIN_BUYOUT_AMOUNT = 0.1;

const CENT_DIGITS = 2;

export interface BuyoutRatesInterface {
    enabled: boolean;
    margin_percent: number;
    loss_percent: number;
}

interface BuyoutParamsInterface {
    amount: number;
    betCoef: number;
    currentCoef: number;
    rates: BuyoutRatesInterface;
}

export const calculateBuyoutAmount = ({amount, betCoef, currentCoef, rates}: BuyoutParamsInterface): number | null => {
    if (!amount || !betCoef || !currentCoef || currentCoef <= 0) {
        return null;
    }

    const stake = new Decimal(amount);
    const value = stake.mul(betCoef).div(currentCoef);
    const payoutFactor = new Decimal(100).minus(rates.margin_percent).div(100);
    const raw = value.gte(stake)
        ? value.mul(payoutFactor)
        : value.mul(payoutFactor).minus(stake.minus(value).mul(new Decimal(rates.loss_percent).div(100)));
    const payout = raw.toDecimalPlaces(CENT_DIGITS, Decimal.ROUND_DOWN);

    return payout.lessThan(MIN_BUYOUT_AMOUNT) ? null : payout.toNumber();
};
